import styled from 'styled-components'
import { useSelector, useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'

import * as feedbackSelector from 'selectors/feedback'
import { showSidebarForm, hideSidebarForm } from 'reducers/feedback'

import IconLink from 'components/Shared/IconLink/Index'
import Tooltip from 'components/Shared/Tooltip/Index'

const StyledWrapper = styled.div`
  margin-right: 8px;
`

const NavFeedback = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const isFeedbackSidebarFormVisible = useSelector(feedbackSelector.isFeedbackSidebarFormVisible)

  const onClick = () => {
    const action = isFeedbackSidebarFormVisible ? hideSidebarForm() : showSidebarForm()
    dispatch(action)
  }

  const onKeyDown = (e) => {
    if (e.key === 'Enter') {
      onClick()
    }
  }

  return (
    <StyledWrapper>
      <Tooltip id='feedback-button' />
      <IconLink
        iconName='icon-feedback'
        onClick={onClick}
        active={isFeedbackSidebarFormVisible}
        data-tooltip-content={t('feedbackSidebarForm.menuButtonTooltip')}
        data-tooltip-id='feedback-button'
        data-feedback-form-activator
        tabIndex={0}
        onKeyDown={onKeyDown}
      />
    </StyledWrapper>
  )
}

export default NavFeedback
